import React, {useEffect, useState} from 'react';
import {useColor} from "../contexts/ColorContext";
import PropTypes from "prop-types";
import FormInputError from "./FormInputError";

interface NumberBoxInputProps {
    className?: string;
    initialValue?: number;
    onValueChange?: (value: number) => void;
    label?: string;
    errorMessage?: string;
}

const propTypes = {
    initialValue: PropTypes.number,
    errorMessage: PropTypes.string,
    label: PropTypes.string
}

const defaultProps = {
    initialValue: 0,
    errorMessage: null
}

function NumberBoxInput({
    className,
    initialValue,
    onValueChange,
    label,
    errorMessage
}: NumberBoxInputProps){
    const {colors} = useColor()
    const inputStyle = {
        width: '45px',
        height: '40px',
        backgroundColor: colors.greyLight,
        padding: '10px',
        border: '0'
    }
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        setValue(initialValue); // Update the state when initialValue changes
    }, [initialValue]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value as any);
        onValueChange?.(Number(event.target.value)); // Call onValueChange with updated value
    };

    return (
        <>
            <div className="d-flex mb-2 font-xs font-bold">{label}</div>
            <div className="d-flex">
                <input
                    className={className}
                    placeholder={'99'}
                    type="number"
                    value={value}
                    onChange={handleChange}
                    style={inputStyle}/>
                {
                    errorMessage &&
                    <FormInputError className="mx-2">{errorMessage}</FormInputError>
                }
            </div>
        </>
    );
}

NumberBoxInput.propTypes = propTypes;
NumberBoxInput.defaultProps = defaultProps;

export default NumberBoxInput;
